import React, { Component } from 'react';


class addToDo extends Component {
  render() {
    return (
        <div className="App">
        <h1>Add To do to the list</h1>
        To do : <input type ="text" onChange= {this.changeValue} name= "cite"></input>
        <button>Add</button>
        <br/><br/><br/>
        </div>
    );
  }
}

export default addToDo;
